import ApiRequestManagerInstance from '../ApiRequestManager';

interface IQuota {
  availableRecordingsDays: number;
  quota: number;
  used: number;
}

interface IQuotaRequest {
  data: IQuota;
}

function quotaRequest() {
  const promise = new Promise<IQuota>(async (resolve) => {
    try {
      const response: IQuotaRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v4',
          section: 'user',
          subsection: 'getQuota',
        },
      })) as unknown as IQuotaRequest;
      resolve(response.data);
    } catch (e) {
      console.error(e);
      resolve({ availableRecordingsDays: 0, quota: 0, used: 0 });
    }
  });

  return promise;
}

export default quotaRequest;
